import { FEATURE_FLAGS } from '../../image/labelling/constants';
import { isFeatureEnabled } from '../utils/utils';
import useFeatureFlag from './useFeatureFlag';

/**
 * Hook to check if the remaining items side panel M3 is enabled
 * @param shouldShowRemainingItems - Whether the remaining items should be shown
 * @returns Whether the remaining items side panel M3 is enabled
 */
export const useEnableRemainingItemsM3Panel = (shouldShowRemainingItems: boolean) => {
  const featureFlagResponse = useFeatureFlag(FEATURE_FLAGS.ENABLE_REMAINING_ITEMS_SIDE_PANEL_M3);
  return shouldShowRemainingItems && isFeatureEnabled(FEATURE_FLAGS.ENABLE_REMAINING_ITEMS_SIDE_PANEL_M3, featureFlagResponse);
};